import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import { IconButton, InputLabel, Tooltip, Typography } from '@mui/material';

import Flex from '@Components/Bases/Flex';
import { FormDatePicker, FormInput } from '@Components/Form';
import { disabledDatePickerTypingStyles } from '@Components/Form/styles';
import FormatNumberInput from '@Components/FormattedNumberInput/FormatNumberInput';
import dayjs from 'dayjs';

type OtherGreenhouseGasTermTargetProps = {
  title: string;
  fieldPath: string;
  isCompletedTh: boolean;
  isCompletedEn: boolean;
};

const OtherGreenhouseGasTermTarget = ({
  title,
  fieldPath,
  isCompletedTh,
  isCompletedEn,
}: OtherGreenhouseGasTermTargetProps) => {
  const currentYear = dayjs().startOf('year');

  return (
    <>
      <Flex mt={1} alignItems={'center'}>
        <Typography fontWeight={800} component={'li'}>
          {title}
        </Typography>
        <Tooltip
          placement="top"
          arrow
          title={
            'ควรระบุปีเป้าหมายให้สอดคล้องกับแนวทางหรือมาตรฐานที่บริษัทใช้อ้างอิงในการตั้งเป้าหมาย'
          }
        >
          <IconButton size="small">
            <HelpOutlineOutlinedIcon sx={{ fontSize: 16 }} />
          </IconButton>
        </Tooltip>
      </Flex>
      <Flex alignItems={'baseline'} gap={2} mt={1}>
        <InputLabel
          required
          sx={{ textAlign: 'end', minWidth: '350px', paddingLeft: 6 }}
        >
          ปีเป้าหมาย
        </InputLabel>
        <FormDatePicker
          disabled={isCompletedTh || isCompletedEn}
          name={`${fieldPath}.year`}
          sx={{ width: '100%', ...disabledDatePickerTypingStyles }}
          views={['year']}
          format="BBBB"
          minDate={currentYear}
          placeholder="เลือกปีเป้าหมาย"
          slotProps={{
            field: { clearable: true },
            toolbar: { hidden: false },
          }}
          localeText={{ toolbarTitle: 'เลือก ปี' }}
        />
      </Flex>
      <Flex alignItems={'baseline'} gap={2} mt={2}>
        <InputLabel
          required
          sx={{
            textAlign: 'end',
            minWidth: '350px',
            paddingLeft: 6,
            wordWrap: 'break-word',
            overflowWrap: 'break-word',
            whiteSpace: 'normal',
          }}
        >
          การลดสัดส่วนหรือปริมาณการปล่อยก๊าซเรือนกระจกเทียบกับปีฐาน
        </InputLabel>
        <FormInput
          disabled={isCompletedTh || isCompletedEn}
          name={`${fieldPath}.gasEmissionPercent`}
          label="เปอร์เซ็นต์"
          placeholder="(%)"
          sx={{
            width: '50%',
            '& input': {
              textAlign: 'right',
            },
          }}
          slotProps={{
            input: {
              inputComponent: FormatNumberInput as React.ComponentType,
              inputProps: {
                useThousandSeparator: false,
                allowNegative: false,
                max: 100,
              },
            },
            inputLabel: {
              style: {
                fontSize: 12,
              },
            },
          }}
        />
        <Typography>หรือ</Typography>
        <FormInput
          disabled={isCompletedTh || isCompletedEn}
          name={`${fieldPath}.gasEmissionQuantity`}
          label={
            <Typography>
              ตันคาร์บอนไดออกไซด์เทียบเท่า, tCO<sub>2</sub>e
            </Typography>
          }
          placeholder="โปรดระบุจำนวน"
          sx={{
            width: '100%',
            '& input': {
              textAlign: 'right',
            },
          }}
          slotProps={{
            input: {
              inputComponent: FormatNumberInput as React.ComponentType,
              inputProps: {
                allowNegative: false,
              },
            },
            inputLabel: {
              style: {
                fontSize: 12,
              },
            },
          }}
        />
      </Flex>
    </>
  );
};

export default OtherGreenhouseGasTermTarget;
